var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{staticClass:"icon",attrs:{"tooltip":_vm.$t(_vm.value === 1 ? 'Published': 'Not published')}},[(_vm.value)?_c('i',{staticClass:"status-is-available fas fa-eye"}):_c('i',{staticClass:"status-not-available fas fa-eye-slash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }